import { Component, OnInit } from '@angular/core';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-email-templates',
  templateUrl: './email-templates.component.html',
  styleUrls: ['./email-templates.component.css']
})
export class EmailTemplatesComponent implements OnInit {
    public grid?: GridOptions;

    constructor(private stateService: StateService) {

    }

    private createGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_emailtemplates_grid')
                .setLoadDataFunction({
                    method: 2896,
                    parameters: {}
                })
                .setKendoConfig({ height: '100%' })
                .setCustomToolbarButtons([{
                    name: 'emailtemplates_new',
                    text: 'emailtemplates_new',
                    func: () => this.stateService?.go('emailtemplate', { emailtemplate_keyno: '0' }),
                    icon: 'fas fa-plus',
                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
                    translate: true
                }]);
        }
    }

    private async init() {
        this.createGrid();
    }

    ngOnInit() {
        this.init();
    }
}



//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('emailTemplates', {
//        templateUrl: 'views/components/views/emailtemplates/emailtemplates.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'ttGridFactory', function (stateService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                gridReady: false
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_emailtemplates_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            }).setCustomToolbarButtons([{
//                name: 'emailtemplates_new',
//                text: 'emailtemplates_new',
//                func: () => stateService.go('emailtemplate', { emailtemplate_keyno: '0' }),
//                icon: 'fa-plus',
//                cssClass: 'btn btn-primary im-grid-btn-xs-r',
//                translate: true
//            }]);

//            // #endregion VARIABLES & DEFINITIONS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                vm.grid.dataTask.loadData = {
//                    method: 2896,
//                    parameters: {}
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadGrid();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
